<template>
  <transition name="fade">
    <div class="flex flex-col items-center justify-center absolute w-full h-full pin-y pin-l z-1010 bg-overlay p-2" ref="modal" @keyup.esc="close" tabindex="0">
      <div class="rounded bg-white relative p-4" :class="[heightClass, schools.length ? 'w-full' : '']">
        <div class="absolute pin-t pin-r mr-2 mt-2 cursor-pointer" @click="close">
          <v-icon scale="1" class="self-center" name="times" color="#6f6f70" />
        </div>
        <div class="">
          <div class="text-grey-darkest text-sm font-bold">{{ selectedDistrict.nama_kabkota }}</div>
          <div class="text-grey-darkest text-sm">Zona: {{ selectedZone.kode_zonasi }}</div>

          <div class="flex flex-col lg:flex-row justify-between items-center mt-2">
            <div class="flex flex-row">
              <div class="relative w-40">
                <select class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-1 px-2 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-grey" v-model="selectedZone.zonasi_id" @change="fetchRecap">
                  <option disabled value="">-- Pilih Zona --</option>
                  <option v-for="(zone, index) in zones" :key="index" :value="zone.zonasi_id" :selected="selectedZone.zonasi_id === zone.zonasi_id">{{ zone.kode_zonasi }}</option>
                </select>
                <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
                  <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
              <div class="ml-2 relative w-40">
                <select class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-1 px-2 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-grey" v-model="selectedSchoolLevel" @change="fetchRecap">
                  <option disabled value="">-- Pilih Jenjang --</option>
                  <option value="SD" :selected="selectedSchoolLevel === 'SD'">SD</option>
                  <option value="SMP" :selected="selectedSchoolLevel === 'SMP'">SMP</option>
                  <option value="SMA" :selected="selectedSchoolLevel === 'SMA'">SMA</option>
                </select>
                <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
                  <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>
            <div class="lg:mt-0 mt-2">
              <pagination v-if="paginationData.lastPage > 1" :pagination="paginationData" :offset="offset" @paginate="fetchRecap()"></pagination>
            </div>
          </div>

          <div class="text-grey-darker text-sm mt-2 overflow-x-auto overflow-y-auto h-full flex" v-if="selectedZone.zonasi_id && selectedSchoolLevel">
            <div v-if="isLoadingData" class="flex my-8 mx-auto">
              <v-icon name="spinner" scale="2" pulse class="text-brand" />
            </div>
            <table v-else class="table-auto w-full">
              <thead class="text-center">
                <tr class="whitespace-no-wrap">
                  <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light" rowspan="2">No</th>
                  <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light" rowspan="2">Nama Sekolah</th>
                  <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light" rowspan="2">Kepala Sekolah</th>
                  <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light" :colspan="courses.length">Kelebihan/Kekurangan</th>
                </tr>
                <tr>
                  <th class="p-1 bg-grey-lighter font-sans text-xs text-grey-dark border border-grey-light" v-for="(course, index) in courses" :key="index">{{ course }}</th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr class="hover:bg-blue-lightest" v-for="(school, index) in schools" :key="index">
                  <td class="p-1 border border-grey-light text-center">{{ index + paginationData.from }}</td>
                  <td class="p-1 border border-grey-light whitespace-no-wrap">{{ school.nama }}</td>
                  <td class="p-1 border border-grey-light whitespace-no-wrap">{{ schoolHead(school.kepala_sekolah) }}</td>
                  <td class="p-1 border border-grey-light text-center" v-for="(guru, index) in school.guru" :key="index">{{ guru }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import {
  TOGGLE_MODAL_RECAP_DISTRICT
} from '@/mutationTypes'
import Pagination from '@/components/Pagination'

export default {
  name: 'modal-recap',
  components: {
    pagination: Pagination
  },
  mounted () {
    this.$nextTick(() => this.$refs.modal.focus())
    this.fetchZones()
  },
  computed: {
    ...mapState(['selectedDistrict', 'selectedLevel'])
  },
  data () {
    return {
      zones: [],
      selectedZone: {
        zonasi_id: '',
        kode_zonasi: ''
      },
      selectedSchoolLevel: 'SD',
      schoolLevel: 'SD',
      courses: [],
      schools: [],
      isLoadingData: false,
      recap: {
        'sekolah_id': '',
        'kode_wilayah': '',
        'kode_kabkota': '',
        'kode_wilayah_propinsi': '',
        'nama_kecamatan': '',
        'nama_kabkota': '',
        'nama_propinsi': '',
        'nama_sekolah': '',
        course: [],
        before: {
          teacher: []
        },
        after: {
          teacher: []
        }
      },
      limit: 10,
      offset: 10,
      paginationData: {
        currentPage: 1
      }
    }
  },
  methods: {
    close () {
      this.$store.dispatch(TOGGLE_MODAL_RECAP_DISTRICT, false)
    },
    async fetchZones () {
      try {
        let response = await fetch(process.env.VUE_APP_API_URL + '/api/simrasio/getZoneByDistrict/' + this.selectedDistrict.kode_wilayah)
        let json = await response.json()
        if (json.status === 200) {
          this.zones = json.result
          // console.log(this.zones)
        }
      } catch (err) {
        // console.log(err)
      }
    },
    async fetchRecap () {
      if (this.schoolLevel !== this.selectedSchoolLevel) {
        this.paginationData.currentPage = 1
      }
      this.schoolLevel = this.selectedSchoolLevel
      if (this.selectedSchoolLevel && this.selectedZone.zonasi_id) {
        try {
          this.isLoadingData = true
          let response = await fetch(process.env.VUE_APP_API_URL + '/api/simrasio/detailZoneByLevel/' + this.selectedSchoolLevel + '/' + this.paginationData.currentPage + '/' + this.limit + '/' + this.selectedZone.zonasi_id)
          let json = await response.json()
          this.isLoadingData = false
          // console.log(json)
          if (json.status === 200) {
            this.courses = json.properties.courses
            this.paginationData = json.properties.pagination
            this.schools = json.properties.data
          }
        } catch (err) {
          // console.log(err)
        }
      }
    },
    schoolHead (kepsek) {
      if (kepsek.status) {
        let arrStr = []
        if (kepsek.is_pns) {
          arrStr.push('PNS')
        } else {
          arrStr.push('Non-PNS')
        }
        arrStr.push(kepsek.nama_ijazah_terakhir)
        if (kepsek.is_sertifikasi) {
          arrStr.push('Sertifikasi')
        } else {
          arrStr.push('Belum Sertifikasi')
        }
        return arrStr.join('/')
      } else {
        return 'Tidak ada'
      }
    },
    heightClass () {
      switch (this.selectedLevel) {
        case 'SD':
          return 'h-48'
        case 'SMP':
          return 'h-128'
        case 'SMA':
          return 'h-144'
        default:
          return 'h-128'
      }
    },
    bgColor (condition) {
      switch (condition) {
        case 'Sesuai':
          return 'bg-success-light'
        case 'Kurang':
          return 'bg-cta-light'
        case 'Lebih':
          return 'bg-warning-light'
        default:
          return ''
      }
    }
  }
}
</script>
